import React from 'react';
import { IconButton, Typography } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';
import OrdersLinesAddMerchDialog from '../../components/OrdersLinesAddMerchDialog';

interface OrdersDetailsSectionMerchPointsProps {
	orderUid: string;
	orderStatusId?: number;
	pricingGroupId?: number;
	orderMerchandise?: any[];
	orderTotMerchPointsSpent?: number;
	orderTotMerchPointsEarned?: number;
	updateRefresh?: () => void;
}

export default function OrdersDetailsSectionMerchPoints(props: OrdersDetailsSectionMerchPointsProps) {
	const { t } = useSettings();

	const isEditable = props.orderStatusId === 1;
	const isMerchIrregular = (props.orderTotMerchPointsSpent || 0) > (props.orderTotMerchPointsEarned || 0);

	const [isDialogOpen, setIsDialogOpen] = React.useState(false);

	return (
		<>
			<DetailsSectionWrapper
				title={t('ORDERS_MERCHPOINTS_SECTION_TITLE')}
				subheader={
					<div className="flex items-center">
						{isMerchIrregular && <Icon icon="alert-circle" color="error.main" />}
						<Typography variant="h4" color={isMerchIrregular ? 'error.main' : undefined}>
							{props.orderTotMerchPointsSpent || 0}
						</Typography>
						<Typography variant="h4">{`/${props.orderTotMerchPointsEarned || 0}`}</Typography>
					</div>
				}
				headerAction={
					<IconButton onClick={() => setIsDialogOpen(true)}>
						<Icon icon={isEditable ? 'edit' : 'list-box'} />
					</IconButton>
				}
			/>
			<OrdersLinesAddMerchDialog
				open={isDialogOpen}
				closeDialog={() => setIsDialogOpen(false)}
				orderUid={props.orderUid}
				pricingGroupId={props.pricingGroupId}
				existingRows={props.orderMerchandise || []}
				totalPointsEarned={props.orderTotMerchPointsEarned}
				isEdit={isEditable}
				updateRefresh={props.updateRefresh}
			/>
		</>
	);
}
